import type { ApolloError } from "@apollo/client";
import type { captureException as CaptureSentryException } from "@sentry/browser";
import { env } from "@/env";
import { captureException as captureSentryException } from "@sentry/browser";

export const captureException = (
  err: unknown,
  context?: Parameters<typeof CaptureSentryException>[1],
) => {
  if (env.VITE_NODE_ENV === "production") {
    captureSentryException(err, context);
  } else {
    console.error((err as ApolloError).message);
  }
};
